import NoAdultContentIcon from '@mui/icons-material/NoAdultContent';
import FastfoodIcon from "@mui/icons-material/Fastfood";
import PetsIcon from "@mui/icons-material/Pets";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import ChildFriendlyIcon from "@mui/icons-material/ChildFriendly";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import ChairIcon from "@mui/icons-material/Chair";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import SchoolIcon from "@mui/icons-material/School";
import KitchenIcon from "@mui/icons-material/Kitchen";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import MovieIcon from "@mui/icons-material/Movie";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ComputerIcon from "@mui/icons-material/Computer";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import BuildIcon from "@mui/icons-material/Build";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import TvIcon from "@mui/icons-material/Tv";
import FlightIcon from "@mui/icons-material/Flight";

const ShoeSneaker = ({ sx }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" style={sx} viewBox="0 0 24 24">
        <title>shoe-sneaker</title>
        <path d="M2 15C2 15 2 12 4 12C4.68 12 5.46 11.95 6.28 11.82C7.2 12.54 8.5 13 10 13H10.25L8.56 11.29C8.91 11.18 9.25 11.05 9.59 10.91L11.5 12.82C11.89 12.74 12.25 12.63 12.58 12.5L10.55 10.45C10.85 10.28 11.14 10.11 11.43 9.91L13.5 12C13.8 11.79 14.04 11.56 14.25 11.32L12.22 9.29C12.46 9.07 12.7 8.83 12.92 8.58L14.79 10.45C14.91 10.14 15 9.83 15 9.5C15 8.65 14.55 7.89 13.84 7.28C13.89 7.19 13.95 7.1 14 7L15.53 6.23C16.38 7.17 18.14 7.84 20.25 7.97L20.3 8H21C21 8 22 9 22 12.5C22 13.07 22 13.57 21.96 14H19C17.9 14 16.58 14.26 15.3 14.5C14.12 14.76 12.9 15 12 15H2M21 17C21 17 21.58 17 21.86 15H19C17 15 14 16 12 16H2.28C2.62 16.6 3.26 17 4 17H21Z" />
    </svg>
);

export const categoryIcons = {
    "adulto": NoAdultContentIcon,
    "alimentos-e-bebidas": FastfoodIcon,
    "animais-pet": PetsIcon,
    "automotivo": DirectionsCarIcon,
    "bebe-criancas": ChildFriendlyIcon,
    "beleza": FaceRetouchingNaturalIcon,
    "calcados": ShoeSneaker,
    "moveis": ChairIcon,
    "cine-foto": PhotoCameraIcon,
    "educacao": SchoolIcon,
    "eletrodomesticos": KitchenIcon,
    "eletronicos": DevicesOtherIcon,
    "entretenimento": MovieIcon,
    "esportes": SportsSoccerIcon,
    "games": SportsEsportsIcon,
    "geek": SmartToyIcon,
    "informatica": ComputerIcon,
    "livros": MenuBookIcon,
    "moda-feminina": CheckroomIcon,
    "moda-masculina": ShoppingBagIcon,
    "musica": MusicNoteIcon,
    "notebooks": LaptopMacIcon,
    "presentes": CardGiftcardIcon,
    "saude": HealthAndSafetyIcon,
    "servico": BuildIcon,
    "smartphone-tablet": PhoneIphoneIcon,
    "tv-audio": TvIcon,
    "viagem": FlightIcon,
};